import { tokenManager } from '../utils/api';
import { USER_URL } from '../config/environment';
import axios from 'axios';

/**
 * Reports Service
 * Handles all reports-related API calls
 */

export const reportsService = {
  /**
   * Get click data
   * @param {Object} filterData - Filter parameters
   * @returns {Promise<Object>} Click data
   */
  getClickData: async (filterData) => {
    const response = await axios.post(`${USER_URL}/api/click-data`, filterData, {
      headers: { Authorization: `Bearer ${tokenManager.getAccessToken()}` }
    });
    return response.data;
  },

  /**
   * Export click data
   * @param {Object} params - Export parameters
   * @returns {Promise<Blob>} Export file blob
   */
  exportClickData: async (params) => {
    const response = await axios({
      method: "get",
      url: `${USER_URL}/api/click-data/export`,
      params,
      headers: { Authorization: `Bearer ${tokenManager.getAccessToken()}` },
      responseType: "blob"
    });
    return response.data;
  },

  /**
   * Get accounts data
   * @returns {Promise<Array>} Accounts data
   */
  getAccounts: async () => {
    const response = await axios.get(`${USER_URL}/api/account-configs/account`, {
      headers: { Authorization: `Bearer ${tokenManager.getAccessToken()}` }
    });
    return response.data;
  }
};

export default reportsService;
